@if(showForm()){

    <survey-header 
        [isModal]="isModal" 
        [languages]="languages" 
        [surveyName]="surveyName" 
        [logo]="surveyLogo" 
    />

    <div class="survey-content" [ngStyle]="{'background': surveyStyle?.bg_color || '#fff'}">
        <form [formGroup]="surveyForm" [ngStyle]="{'background': surveyStyle?.survey_color || '#FFF'}">
            @for(data of formData; track $index) {
                <div class="question-entry">
                    <label class="question-entry__title" [ngStyle]="{'color': surveyStyle?.text_color}">{{data.title}}</label>
    
                    @if(data.type === 'satisfaction_level_3' || data.type === 'satisfaction_level_5'){
                        <div class="question-entry__faces-container">
                            @for(face of data.options; track $index) {
                                <label>
                                    <input type="radio" [value]="face" [formControlName]="data.key" [name]="data.key" (change)="setSelectedOption(face, data.key)">
                                    <img src="/assets/imgs/face-{{ data.options.length }}-{{ face }}.png" draggable="false" [ngClass]="surveyForm.value?.[data?.key] === face ? 'selected animate__animated animate__rubberBand' : 'no_selected'" >
                                </label>
                            }
                        </div>
                    }
    
                    @if(data.type === 'text'){
                        <input type="text" [formControlName]="data.key" [name]="data.key">
                    }
    
                    @if(data.type === 'selection_unique'){
                        <div class="question-entry__selection-survey">
                            @for(option of  data.options; track $index) {
                                <div class="question-entry__selection-survey__question">
                                    <input type="radio" [value]="option" [formControlName]="data.key" [name]="data.key" (change)="setSelectedOption(option, data.key)" />
                                    <span [ngClass]="surveyForm.value[data.key] == option ? 'selected animate__animated animate__rubberBand' : ''"></span>
                                    <label [ngStyle]="{'color': surveyStyle.text_color}">{{ option| translate }}</label>
                                </div>
                            }
                        </div>
                    }
    
                    @if(data.type === 'selection_multi'){
                        <div [formArrayName]="data.key" class="question-entry__selection-survey">
                            @for(option of getMultiControls(data.key); track $index) {
                                <div class="question-entry__selection-survey__question">
                                    <input type="checkbox" [formControl]="$any(option.get('selected'))" />
                                    <span [ngClass]="option.value.selected  ? 'selected animate__animated animate__rubberBand' : ''"></span>
                                    <label [ngStyle]="{'color': surveyStyle.text_color}">{{ option.get('value').value | translate }}</label>
                                </div>
                            }
                        </div>
                    }
    
                    <hr>
                </div>
            }

            <div class="send-button">
                <button (click)="sendSurvey()">{{'Enviar' | translate}}</button>
            </div>

        </form>
    </div>
}
